<div *ngIf="isVisible" class="meeting-drag-scroll">
  <div class="pane-header" [class.mobile]="deviceService.isMobile()">
  <app-library-title [title]="blockTitle" [class.with-sorting]="_pane.show_sorting">
    <ng-container side>
      <div class="tab-filter">
        <ul class="tabs">
          <li *ngFor="let filter of filters; let i = index; trackBy: trackByFn" class="tab normal"
              [class.active]="i === indexFilterSelected"
              (click)="selectFilter(i)">
            {{ (display(filter) | typeof) === 'string' ?
            (display(filter) | customLocale) : (display(filter) | dfnsFormat: 'dd.MM') }}
          </li>
        </ul>
      </div>
    </ng-container>
  </app-library-title>
  <app-library-sorting *ngIf="_pane.show_sorting" [class.with-more]="blockTitle?.see_all_link" [pane]="_pane"></app-library-sorting>
  </div>
  <ng-template [ngIf]="meetings && meetingsFilter().length > 3 && deviceService.isDesktop()">
    <div class="right-btn" (click)="moveRight()">
      <app-icon class="right-arrow" icon="drag-scroll-arrow"></app-icon>
    </div>

    <div class="left-btn" (click)="moveLeft()">
      <app-icon class="left-arrow" icon="drag-scroll-arrow"></app-icon>
    </div>
  </ng-template>

  <ng-template [ngIf]="deviceService.isDesktop()" [ngIfElse]="mobile">
    <ng-template [ngIf]="meetingsFilter().length > 3" [ngIfElse]="banner">
      <cdk-virtual-scroll-viewport #scroller [itemSize]="itemSize" class="scroll-viewport" orientation="horizontal">
        <div *cdkVirtualFor="let meeting of meetingsFilter(); let i = index; trackBy: trackByFn" class="scroll-item">
          <app-meeting-mini-card [meeting]="meeting" (openCard)="onOpenCard(i)"></app-meeting-mini-card>
        </div>
      </cdk-virtual-scroll-viewport>
    </ng-template>

    <ng-template #banner>
      <div class="scroll-wrap">
        <div *ngFor="let meeting of meetingsFilter(); let i = index; trackBy: trackByFn" class="scroll-item">
          <app-meeting-mini-card [meeting]="meeting" (openCard)="onOpenCard(i)"></app-meeting-mini-card>
        </div>

        <ng-template [ngIf]="meetingsFilter().length < 3">
          <div class="scroll-item">
            <app-free-date-banner [displayMode]="displayModeBanner"></app-free-date-banner>
          </div>
        </ng-template>
      </div>
    </ng-template>
  </ng-template>

  <ng-template #mobile>
    <div class="responsive-scroll-viewport">
      <div *ngFor="let meeting of meetingsFilter(); let i = index; trackBy: trackByFn" class="scroll-item">
        <app-meeting-mini-card [meeting]="meeting" (openCard)="onOpenCard(i)"></app-meeting-mini-card>
      </div>
      <ng-template [ngIf]="!meetingsFilter().length">
        <div class="scroll-item">
          <app-free-date-banner displayMode="short"></app-free-date-banner>
        </div>
      </ng-template>
    </div>
  </ng-template>
</div>

<app-modal *ngIf="deviceService.isDesktop() && showModal"
           [canClose]="false"
           (closed)="onCloseModal($event)"
           [prevNext]="true"
           [reachedPrev]="reachedPrev"
           [reachedNext]="reachedNext"
           (togglePrev)="togglePrev($event)"
           (toggleNext)="toggleNext($event)">
  <app-modal-body>
    <app-meeting-card [meeting]="item" [modal]="true" (close)="onCloseCard()"></app-meeting-card>
  </app-modal-body>
</app-modal>

<app-mobile-modal *ngIf="!deviceService.isDesktop() && showModal" (closed)="onCloseModal($event)">
  <app-mobile-modal-body>
    <app-meeting-card [meeting]="item" [modal]="true" (close)="onCloseCard()"></app-meeting-card>
  </app-mobile-modal-body>

  <app-mobile-modal-actions></app-mobile-modal-actions>
</app-mobile-modal>
